import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <>
      <style>{`
          .my-footer {
            left: 0;
            width: 100%;
            padding-top: 1rem;
            padding-bottom: 1rem;
            margin-top: auto;
            background-color: rgba(33, 37, 41, .12) !important;
            backdrop-filter: blur(6px);
            color: white;
            text-align: center;
            transition: all 0.2s ease;
            position: relative;
            z-index: 100;
          }
        `}</style>

      <div className="my-footer">
        <div className="text-muted">
          <div style={{ color: 'white' }}>
            <a style={{ textDecoration: 'none', color: 'white' }} href="/">Home</a> |{' '}
            <a style={{ textDecoration: 'none', color: 'white' }} href="mailto:info@justinkim.dev">Contact</a>
          </div>
          <div style={{ color: 'white' }}>&copy; 2023 JustinKim.dev</div>

          {/* <div id="freepik-attribution" className="mt-2">
            <div className="footer-min-769">
              <a
                className="pb-1"
                style={{ textDecoration: 'none', backgroundColor: 'rgba(0, 0, 0, 0.5)', paddingInline: '10px', borderRadius: '10px', color: 'white', fontWeight: 'lighter', background: 'aliceblue' }}
                href="https://www.freepik.com/free-photo/beautiful-skyscape-daytime_22542947.htm#fromView=search&page=1&position=12&uuid=00a49432-9a63-44e8-be99-fdfdb4e1d1da&query=sky"
              >
                <span className="text-muted small">Image by wirestock on Freepik</span>
              </a>
            </div>
            <div className="footer-max-768">
              <a
                className="pb-1"
                style={{ textDecoration: 'none', backgroundColor: 'rgba(0, 0, 0, 0.25)', paddingInline: '10px', borderRadius: '10px', color: 'white', fontWeight: 'lighter', background: 'lightgrey' }}
                href="https://www.freepik.com/free-photo/beautiful-mountain-landscape_17239856.htm"
              >
                <span className="text-muted small">Image by wirestock on Freepik</span>
              </a>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
}

export default Footer;
